export const isSuit = (label)=> !!ALL_SUITS.find((x) => x === label);
export const isSpecialty = (label) =>
	!!ALL_SPECIALTIES.find((x) => x === label);
export const isPowerValue = (label) =>
	!!ALL_POWER_VALUES.find((x) => x === label);
export const isSkillValue = (label)=>
	!!ALL_SKILL_VALUES.find((x) => x === label);
export const toSkill = (skv) => {
	switch (skv) {
		case 'research':
			return 'res-skill';
		case 'influence':
			return 'inf-skill';
		case 'military':
			return 'mil-skill';
		case 'wild':
			return 'wild-skill';
		case 'variable':
			return 'variable-skill';
		case 'treachery':
			return 'tre-skill';
		default:
			throw new Error(`'${skv}' is not a valid skill value`);
	}
};
export const toFocus = (fv) => {
	switch (fv) {
		case 'research':
			return 'res-focus';
		case 'influence':
			return 'inf-focus';
		case 'military':
			return 'mil-focus';
		case 'wild':
			return 'wild-focus';
		case 'treachery':
			return 'tre-focus';
		default:
			throw new Error(`'${fv}' is not a valid skill value`);
	}
};
export const isVp = (label)=> !!ALL_VP.find((x) => x === label);
export const isInlineIcon = (label) =>
	!!ALL_INLINE_ICONTYPES.find((x) => x === label);

export const isStandardTrait = (label) =>
	!!ALL_STANDARD_TRAITS.find((x) => x === label);
export const isSpeciesTrait = (label) =>
	!!ALL_SPECIES_TRAITS.find((x) => x === label);
export const isSpecialTrait = (label) =>
	!!ALL_SPECIAL_TRAITS.find((x) => x === label);
export const isUtilityTrait = (label) =>
	!!ALL_UTILITY_TRAITS.find((x) => x === label);
export const isTrait = (label) => !!ALL_TRAITS.find((x) => x === label);

// Utility traits are ignored everywhere except when explicitly named:
// they don't count towards trait/unique-trait counts and can't be picked for a wildcard.
export const countableTraits = (traits = []) => traits.filter((t) => !isUtilityTrait(t));

export const isOpType = (label) =>
	!!ALL_OP_TYPES.find((x) => x === label);

export const getTraitKind = (label) => {
	if (label === 'wildcard') return 'wild';
	if (isUtilityTrait(label)) return 'utility';
	if (isSpecialTrait(label)) return 'special';
	if (isSpeciesTrait(label)) return 'species';
	if (isStandardTrait(label)) return 'standard';
	return 'standard'; // Don't throw errors...!
	//throw new Error('Unknown trait: ' + label);
};

export const ALL_SUITS = [
	'captain',
	'directive',
	'location',
	'person',
	'cargo',
	'ship',
	'ally',
	'incident',
	'encounter',
	'qsuit',
	'status',
	'mission'
];

const ALL_SPECIALTIES = ['research', 'influence', 'military', 'collective', 'treachery'];
const ALL_POWER_VALUES = ['research', 'influence', 'military', 'wild', 'treachery'];
const ALL_SKILL_VALUES = [...ALL_POWER_VALUES, 'variable'];
export const ALL_SKILLS = [
	'res-skill',
	'inf-skill',
	'mil-skill',
	'wild-skill',
	'tre-skill',
	'variable-skill'
];
export const ALL_FOCUS = ['res-focus', 'inf-focus', 'mil-focus', 'wild-focus', 'tre-focus'];
export const ALL_RESTRICTIONS = [
	'res-restriction',
	'inf-restriction',
	'mil-restriction',
	'col-restriction',
	'tre-restriction',
	'cap-restriction'
];
const ALL_RESOURCES = ['glory', 'dilithium', 'latinum', 'power', 'whim'];
const ALL_VP = [
	'0vp',
	'1vp',
	'2vp',
	'3vp',
	'4vp',
	'5vp',
	'6vp',
	'7vp',
	'8vp',
	'9vp',
	'10vp',
	'?vp',
	'-1vp',
	'-3vp'
];

const ALL_INLINE_ICONTYPES = [
	...ALL_SPECIALTIES,
	...ALL_SKILLS,
	...ALL_RESTRICTIONS,
	...ALL_RESOURCES,
	...ALL_VP,
	...ALL_FOCUS,
	'away team',
	'drone',
	'murf',
	'action',
	'swarm',
	'platoon',
	'web'
];

const ALL_STANDARD_TRAITS = [
	'alliance',
	'ambassador',
	'ancient',
	'anomaly',
	'augment',
	'beverage',
	'business',
	'cloak',
	'communication',
	'creature',
	'crossover',
	'derelict',
	'doctor',
	'dominion',
	'empire',
	'engineer',
	'helmet',
	'hologram',
	'imperial',
	'kazon sect',
	'maquis',
	'mind control',
	'mirror',
	'nx-01',
	'ops',
	'pilot',
	'protostar',
	'resistance',
	'scientist',
	'security',
	'shady',
	'spy',
	'starbase',
	'starfleet',
	'supervisor',
	'telepath',
	'time travel',
	'weapon'
];
const ALL_SPECIES_TRAITS = [
	'aenar',
	'alien',
	'andorian',
	'android',
	'any species',
	'bajoran',
	'betazoid',
	'borg',
	'breen',
	'cardassian',
	'changeling',
	'different species',
	'el-aurian',
	'ferengi',
	'gorn',
	'hirogen',
	'human',
	"jem'hadar",
	"kazon",
	'kelpien',
	'klingon',
	'orion',
	'pakled',
	'reman',
	'romulan',
	'synthetic',
	'talaxian',
	'tellarite',
	'terran',
	'tholian',
	'transcendent',
	'trill',
	"vau n'akat",
	'vorta',
	'vulcan',
	'xb',
	'xindi'
];
const ALL_UTILITY_TRAITS = [
	'path of surak',
	'journey',
	'irrelevant',
	'cube',
	'sync',
	'continuum',
	'wounded',
	'rule of acquisition',
	'story',
	'legendary',
	'redshirt'
]
const ALL_SPECIAL_TRAITS = [
	'attack',
	'attachment',
	'ongoing',
	'surprise',
	'lower decker'
];
const ALL_TRAITS = [
	...ALL_STANDARD_TRAITS,
	...ALL_SPECIES_TRAITS,
	...ALL_SPECIAL_TRAITS,
	...ALL_UTILITY_TRAITS,
	'wildcard'
];

const ALL_OP_TYPES = [
	'accept',
	'play',
	'support',
	'control',
	'resupply',
	'reaction',
	'activation',
	'passive',
	'special',
	'surprise',
	'clean-up',
	'endgame',
	'cost',
	'goal',
	'reward'
];
